module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_12-c8fb09247eae4bb15a7b32e6fbcc12da.png";